/**
 * Insurance Companies Routes
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// async components
import {
  AsyncManageBalanceRequestsComponent,
  AsyncAddBalanceRequestComponent,
  AsyncModifyBalanceRequestComponent,
} from "../../components/AsyncComponent/AsyncComponent";

const Forms = ({ match }) => (
  <React.Fragment>
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/manage`} />
      <Route
        path={`${match.url}/view-all`}
        component={AsyncManageBalanceRequestsComponent}
      />
      <Route
        path={`${match.url}/create`}
        component={AsyncAddBalanceRequestComponent}
      />
      <Route
        path={`${match.url}/modify`}
        component={AsyncModifyBalanceRequestComponent}
      />
    </Switch>
  </React.Fragment>
);

export default Forms;
